"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var validators_1 = require("./../validators");
var view_models_1 = require("./../view-models");
var view_config_models_1 = require("./../view-config-models");
var validators_2 = require("./../validators");
var TripDetailsControlNames = (function () {
    function TripDetailsControlNames() {
    }
    return TripDetailsControlNames;
}());
TripDetailsControlNames.tripDates = 'tripDates';
TripDetailsControlNames.departureDate = 'departureDate';
TripDetailsControlNames.returnDate = 'returnDate';
TripDetailsControlNames.tripSuppliers = 'tripSuppliers';
TripDetailsControlNames.airline = 'airline';
TripDetailsControlNames.noAirline = 'noAirline';
TripDetailsControlNames.carRentalCompany = 'carRentalCompany';
TripDetailsControlNames.cruiseLine = 'cruiseLine';
TripDetailsControlNames.hotel = 'hotel';
TripDetailsControlNames.rentalCompany = 'rentalCompany';
TripDetailsControlNames.tourOperator = 'tourOperator';
TripDetailsControlNames.tripDestination = 'tripDestination';
TripDetailsControlNames.destination = 'destination';
TripDetailsControlNames.destinationCity = 'destinationCity';
TripDetailsControlNames.destinationState = 'destinationState';
exports.TripDetailsControlNames = TripDetailsControlNames;
var TripDetailsComponent = (function () {
    function TripDetailsComponent(fb, differs) {
        this.fb = fb;
        this.differs = differs;
        this.states = [];
        this.overrideValidation = false;
        this.blockedProvidersClicked = new core_1.EventEmitter();
        this.formInitialized = false;
        this.showNoAirlineBoxBecauseAirlineIsRequired = true;
        this.controlsMap = {};
        this.differ = differs.find([]).create(null);
    }
    Object.defineProperty(TripDetailsComponent.prototype, "maxTripLength", {
        get: function () {
            if (this.policyConfig) {
                return this.policyConfig.tripDates.maxTripLength;
            }
            else {
                return 0;
            }
        },
        enumerable: true,
        configurable: true
    });
    TripDetailsComponent.prototype.onBlockedProviderLinkClicked = function () {
        this.blockedProvidersClicked.emit();
    };
    TripDetailsComponent.prototype.ngOnChanges = function (changes) {
        if (this.tripDetailsForm && this.tripDetails && this.policyConfig && !this.formInitialized) {
            this.setupValidation();
        }
    };
    TripDetailsComponent.prototype.ngDoCheck = function () {
        var _this = this;
        if (this.formInitialized) {
            var changes = this.differ.diff(this.tripDetails);
            if (changes) {
                changes.forEachChangedItem(function (r) {
                    var control = _this.controlsMap[r.key];
                    if (control) {
                        control.setValue(r.currentValue, { onlySelf: true, emitValue: false });
                    }
                });
            }
        }
    };
    TripDetailsComponent.prototype.addControlToGroupAndMap = function (name, control, group) {
        group.addControl(name, control);
        this.controlsMap[name] = control;
    };
    TripDetailsComponent.prototype.getDepartureDateValidators = function (config) {
        var validators = [];
        if (config.required) {
            validators.push(forms_1.Validators.required);
        }
        validators.push(validators_1.departureDateValidator(null, null, this.overrideValidation));
        return validators;
    };
    TripDetailsComponent.prototype.getReturnDateValidators = function (config, departureDateControl, departureDate) {
        if (departureDate === void 0) { departureDate = null; }
        var validators = [];
        if (config.required) {
            validators.push(forms_1.Validators.required);
        }
        if (departureDate) {
            validators.push(validators_2.tripLengthValidator(departureDate, this.maxTripLength));
        }
        validators.push(validators_1.returnDateValidator(departureDateControl, null, null, this.overrideValidation));
        return validators;
    };
    TripDetailsComponent.prototype.setupValidation = function () {
        var _this = this;
        if (this.policyConfig.tripDates.show) {
            // setup validators
            var departureDateValidators = this.getDepartureDateValidators(this.policyConfig.tripDates);
            var departureDateControl_1 = this.fb.control(this.tripDetails.departureDate, forms_1.Validators.compose(departureDateValidators));
            var returnDateValidators = this.getReturnDateValidators(this.policyConfig.tripDates, departureDateControl_1, this.tripDetails.departureDate);
            var returnDateControl_1 = this.fb.control(this.tripDetails.returnDate, forms_1.Validators.compose(returnDateValidators));
            var tripDatesGroup = this.fb.group({});
            departureDateControl_1.valueChanges.subscribe(function (newValue) {
                returnDateControl_1.setValidators(_this.getReturnDateValidators(_this.policyConfig.tripDates, departureDateControl_1, newValue));
                returnDateControl_1.updateValueAndValidity();
            });
            this.addControlToGroupAndMap(TripDetailsControlNames.departureDate, departureDateControl_1, tripDatesGroup);
            this.addControlToGroupAndMap(TripDetailsControlNames.returnDate, returnDateControl_1, tripDatesGroup);
            this.tripDetailsForm.addControl(TripDetailsControlNames.tripDates, tripDatesGroup);
        }
        if (this.policyConfig.destination.show) {
            var destinationControl = this.fb.control(this.tripDetails.destination, this.policyConfig.destination.required ? forms_1.Validators.compose([forms_1.Validators.required]) : []);
            var tripDestination_1 = this.fb.group({});
            // disables the destination country control on purchase or if it's set to not be editable
            if (this.policyConfig.isPurchase || !this.policyConfig.destination.editable) {
                destinationControl.disable();
            }
            this.addControlToGroupAndMap(TripDetailsControlNames.destination, destinationControl, tripDestination_1);
            if (this.policyConfig.destinationCity.show) {
                var destintationCityControl = this.fb.control(this.tripDetails.destinationCity);
                this.addControlToGroupAndMap(TripDetailsControlNames.destinationCity, destintationCityControl, tripDestination_1);
            }
            if (this.policyConfig.destinationState.show) {
                checkDestinationState(this, tripDestination_1);
                tripDestination_1.valueChanges.subscribe(function () {
                    checkDestinationState(_this, tripDestination_1);
                });
            }
            this.tripDetailsForm.addControl(TripDetailsControlNames.tripDestination, tripDestination_1);
        }
        if (this.anySuppliersShown(this.policyConfig)) {
            var tripSuppliersControl = this.fb.group({});
            this.tripDetailsForm.addControl(TripDetailsControlNames.tripSuppliers, tripSuppliersControl);
            this.setupAirline(tripSuppliersControl, this.policyConfig.airline, this.policyConfig.flights);
            this.setupCarRental(tripSuppliersControl, this.policyConfig.carRentalCompany);
            this.setupCruiseLine(tripSuppliersControl, this.policyConfig.cruiseLine);
            this.setupHotel(tripSuppliersControl, this.policyConfig.hotel);
            this.setupRentalCompany(tripSuppliersControl, this.policyConfig.rentalCompany);
            this.setupTourOperator(tripSuppliersControl, this.policyConfig.tourOperator);
        }
        this.formInitialized = true;
        function checkDestinationState(context, formGroup) {
            if (shouldAddDestinationState(context, formGroup)) {
                if (!formGroup.get(TripDetailsControlNames.destinationState)) {
                    addDestinationState(context, formGroup);
                }
            }
            else if (formGroup.get(TripDetailsControlNames.destinationState)) {
                removeDestinationState(context, formGroup);
            }
            function shouldAddDestinationState(context, formGroup) {
                var destinationControl = formGroup.get(TripDetailsControlNames.destination);
                var formValue = (destinationControl.value && destinationControl.value.isoCode2 ? destinationControl.value.isoCode2 : '');
                return ((!formValue && context.tripDetails.destinationCountry === 'US') || formValue === 'US');
            }
        }
        function addDestinationState(context, formGroup) {
            var stateControl = context.fb.control(context.tripDetails.destinationState, forms_1.Validators.compose([forms_1.Validators.required]));
            context.addControlToGroupAndMap(TripDetailsControlNames.destinationState, stateControl, formGroup);
        }
        function removeDestinationState(context, formGroup) {
            formGroup.removeControl(TripDetailsControlNames.destinationState);
            context.controlsMap[TripDetailsControlNames.destinationState] = undefined;
        }
    };
    TripDetailsComponent.prototype.setupAirline = function (form, airlineConfig, flightConfig) {
        if (airlineConfig.show) {
            // Figure out if user input is required
            this.showNoAirlineBoxBecauseAirlineIsRequired = !flightConfig.required;
            // create the form group
            var airlineGroup = new forms_1.FormGroup({});
            // create the airline type-a-head
            var airlineControl_1 = this.fb.control(this.tripDetails.airline);
            // Add the control to the group
            this.addControlToGroupAndMap(TripDetailsControlNames.airline, airlineControl_1, airlineGroup);
            // If user input is required we need to add a "No airline" check box to make sure the users
            // enter an airline or declare that the do not have an airline.
            if (this.showNoAirlineBoxBecauseAirlineIsRequired) {
                // Create the "No airline" cherck box
                var noAirlineControl_1 = this.fb.control(this.tripDetails.airlineNotProvided);
                // add it to the form group
                this.addControlToGroupAndMap(TripDetailsControlNames.noAirline, noAirlineControl_1, airlineGroup);
                // If airline and "No airline" inputs are present one must be filled so we will add validation to the form group
                airlineGroup.setValidators([validators_1.airlineSupplierValidator()]);
                // Set up value changes so the two controls can work together
                airlineControl_1.valueChanges.subscribe(function (newValue) {
                    if (newValue && noAirlineControl_1.value) {
                        noAirlineControl_1.setValue(false);
                    }
                });
                noAirlineControl_1.valueChanges.subscribe(function (newValue) {
                    if (newValue && airlineControl_1.value) {
                        airlineControl_1.setValue('');
                    }
                });
            }
            // Add the form group the the trip suppliers form
            form.addControl('airline', airlineGroup);
        }
    };
    TripDetailsComponent.prototype.setupCarRental = function (form, config) {
        if (config.show) {
            var carRentalControl = this.fb.control(this.tripDetails.carRentalCompany);
            this.addControlToGroupAndMap(TripDetailsControlNames.carRentalCompany, carRentalControl, form);
            if (!config.editable) {
                carRentalControl.disable();
            }
        }
    };
    TripDetailsComponent.prototype.setupCruiseLine = function (form, config) {
        if (this.policyConfig.cruiseLine.show) {
            var cruiseControl = this.fb.control(this.tripDetails.cruise);
            this.addControlToGroupAndMap(TripDetailsControlNames.cruiseLine, cruiseControl, form);
            if (!config.editable) {
                cruiseControl.disable();
            }
        }
    };
    TripDetailsComponent.prototype.setupHotel = function (form, config) {
        if (config.show) {
            var hotelControl = this.fb.control(this.tripDetails.hotel);
            this.addControlToGroupAndMap(TripDetailsControlNames.hotel, hotelControl, form);
            if (!config.editable) {
                hotelControl.disable();
            }
        }
    };
    TripDetailsComponent.prototype.setupRentalCompany = function (form, config) {
        if (config.show) {
            var rentalCompanyControl = this.fb.control(this.tripDetails.rentalCompany);
            this.addControlToGroupAndMap(TripDetailsControlNames.rentalCompany, rentalCompanyControl, form);
            if (!config.editable) {
                rentalCompanyControl.disable();
            }
        }
    };
    TripDetailsComponent.prototype.setupTourOperator = function (form, config) {
        if (config.show) {
            var tourOperatorControl = this.fb.control(this.tripDetails.tourOperator);
            this.addControlToGroupAndMap(TripDetailsControlNames.tourOperator, tourOperatorControl, form);
            if (!config.editable) {
                tourOperatorControl.disable();
            }
        }
    };
    TripDetailsComponent.prototype.anySuppliersShown = function (config) {
        return config && (config.airline.show || config.carRentalCompany.show || config.cruiseLine.show || config.tourOperator.show || config.hotel.show || config.rentalCompany.show);
    };
    return TripDetailsComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", view_models_1.TripDetailsViewModel)
], TripDetailsComponent.prototype, "tripDetails", void 0);
__decorate([
    core_1.Input('form'),
    __metadata("design:type", forms_1.FormGroup)
], TripDetailsComponent.prototype, "tripDetailsForm", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", view_config_models_1.PolicyViewConfig)
], TripDetailsComponent.prototype, "policyConfig", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], TripDetailsComponent.prototype, "states", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], TripDetailsComponent.prototype, "baseUrl", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], TripDetailsComponent.prototype, "submitted", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], TripDetailsComponent.prototype, "overrideValidation", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], TripDetailsComponent.prototype, "blockedProvidersClicked", void 0);
TripDetailsComponent = __decorate([
    core_1.Component({
        selector: 'trip-details',
        template: "<trip-dates *ngIf=\"tripDetailsForm && policyConfig?.tripDates.show\"             [form]=\"tripDetailsForm.controls.tripDates\"             [maxTripLength]=\"maxTripLength\"             [submitted]=\"submitted\"></trip-dates> <trip-destination *ngIf=\"tripDetailsForm && policyConfig?.destination.show\"                   [form]=\"tripDetailsForm.controls.tripDestination\"                   [showDivider]=\"policyConfig?.isPurchase\"                   [submitted]=\"submitted\"                   [states]=\"states\"></trip-destination> <trip-providers *ngIf=\"tripDetailsForm && anySuppliersShown(policyConfig)\"                 [form]=\"tripDetailsForm.controls.tripSuppliers\"                 [submitted]=\"submitted\"                 [baseUrl]=\"baseUrl\"                 [showNoAirline]=\"showNoAirlineBoxBecauseAirlineIsRequired\"                 (blockedProvidersClicked)=\"onBlockedProviderLinkClicked($event)\"></trip-providers>"
    }),
    __metadata("design:paramtypes", [forms_1.FormBuilder, core_1.KeyValueDiffers])
], TripDetailsComponent);
exports.TripDetailsComponent = TripDetailsComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/trip-details/trip-details.component.js